(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.documentElement.style.setProperty(
    '--announcement-bar-height',
    `${document.querySelector('.announcement-bar-section')?.offsetHeight}px`
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  // Adjust width of first column in mega menu align with header navigation
  function adjustMegaMenuFirstColumnWidth() {
    const threshold = document.querySelector('.header__inline-menu .list-menu > li:first-child');
    const megaMenu = document.querySelector('.mega-menu');
    if (threshold && megaMenu) {
      const left = threshold.getBoundingClientRect().left;
      const firstColumn = megaMenu.querySelector('.mega-menu-list-column .column:first-child');
      if (firstColumn) {
        const megaMenuPaddingLeft = '3.5rem';
        const megaMenuGap = '0.75rem';
        const headerPaddingLeft = '3.5rem';
        // const pageWidth = '(100vw - var(--page-width) / 2)';
        const paddingFullWith = `max(0px, calc((100vw - var(--page-width)) / 2) - var(--page-padding-desktop) / 2)`;
        // const width = `calc(${left}px - ${megaMenuPaddingLeft} - ${headerPaddingLeft} - ${megaMenuGap} - ${paddingFullWith})`;
        const width = `calc(${left}px - ${megaMenuPaddingLeft} - ${headerPaddingLeft} - ${megaMenuGap} )`;
        firstColumn.style.width = width;
        firstColumn.style.minWidth = width;
        firstColumn.style.maxWidth = width;
        firstColumn.style.flexGrow = `0`;
      }
    }
  }

  if (window.innerWidth >= 990) {
    adjustMegaMenuFirstColumnWidth();
  }

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 990) {
      adjustMegaMenuFirstColumnWidth();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  // Show Sticky Add To Cart Section after scrolled past Main Buy Button
  function showStickyAddToCart() {
    window.addEventListener('scroll', function () {
      const sectionStickyAddToCart = document.querySelector('.section-sticky-add-to-cart');
      const mainAddToCartButton = document.querySelector('.product__info-container .product-form__buttons');
      const rect = mainAddToCartButton.getBoundingClientRect();

      if (!sectionStickyAddToCart || !mainAddToCartButton) return;

      if (rect.top + mainAddToCartButton.clientHeight <= 0) {
        if (!sectionStickyAddToCart.classList.contains('show')) {
          sectionStickyAddToCart.classList.add('show');
          return;
        }
      } else {
        if (sectionStickyAddToCart.classList.contains('show')) {
          sectionStickyAddToCart.classList.remove('show');
        }
      }
    });
  }

  function handleButtonMobileOnClick() {
    document.getElementById('sticky-add-to-cart-button-mobile').addEventListener('click', function () {
      const productInfoSellingPlans = document.querySelector('.product-form__input--subscription');
      productInfoSellingPlans.scrollIntoView({
        behavior: 'smooth', // smooth scroll
        block: 'center', // Align cehter
      });
    });
  }

  function handleButtonDesktopOnClick() {
    const stickyBuyButtonDesktop = document.querySelector('#sticky-add-to-cart-button-desktop .product-form__submit');
    stickyBuyButtonDesktop.addEventListener('click', function (e) {
      e.preventDefault();
      const productForm = e.target.closest('product-form');
      const submitButton = e.currentTarget;
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      submitButton.querySelector('.loading__spinner').classList.remove('hidden');
      const mainBuyButton = document.querySelector('.product__info-container .product-form__submit');
      mainBuyButton.click(); // Trigger event click on main buy button above

      const handleSuccess = (event) => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        submitButton.querySelector('.loading__spinner').classList.add('hidden');
      };

      const handleError = (event) => {
        productForm.handleErrorMessage(event.errors);
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        submitButton.querySelector('.loading__spinner').classList.add('hidden');
      };

      subscribe(PUB_SUB_EVENTS.cartUpdate, handleSuccess);
      subscribe(PUB_SUB_EVENTS.cartError, handleError);
    });
  }

  function syncSellingPlansSelectionInputs() {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      this.variantId = event.data.variant.id.toString();
      const mainProductFormWrapper = event.data.html.querySelector('product-form').parentElement;
      const stickyProductFormWrapper = document.querySelector(
        '#sticky-add-to-cart-button-desktop product-form'
      ).parentElement;

      const mainSellingPlanInputChecked = event.data.html.querySelector(
        '.product-form__input--subscription input[checked]'
      );

      const stickySellingPlanInput = document.querySelector(
        `.sticky__product-selling-plans input[type="radio"][value="${mainSellingPlanInputChecked.value}"]`
      );

      if (stickySellingPlanInput) {
        stickySellingPlanInput.checked = true;
      }
      if (stickyProductFormWrapper && mainProductFormWrapper) {
        stickyProductFormWrapper.innerHTML = mainProductFormWrapper.innerHTML;
      }
    });

    const stickySellingPlanInputs = document.querySelectorAll('.sticky__product-selling-plans input');
    stickySellingPlanInputs.forEach((radio) => {
      radio.addEventListener('change', (e) => {
        const selectedValue = e.target.value;
        const mainSellingPlanInput = document.querySelector(
          `.product__info-container input[type="radio"][value="${selectedValue}"]`
        );
        mainSellingPlanInput.checked = true;
        mainSellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  showStickyAddToCart();
  handleButtonDesktopOnClick();
  handleButtonMobileOnClick();
  syncSellingPlansSelectionInputs();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-make-us"] && !Shopify.designMode) return;
  try {
    
  const table = document.querySelector('.what-make-us__table-wrapper');
  const buttons = document.querySelector('.what-make-us__buttons');
  const buttonNext = buttons.querySelector('.slider-button--next');
  const buttonPrev = buttons.querySelector('.slider-button--prev');
  buttonNext.addEventListener('click', (e) => {
    buttonPrev.classList.remove('swiper-button-disabled');
    e.currentTarget.classList.add('swiper-button-disabled');
    table.scrollTo({
      left: table.scrollWidth - table.clientWidth + 30,
      behavior: 'smooth',
    });
  });

  buttonPrev.addEventListener('click', (e) => {
    buttonNext.classList.remove('swiper-button-disabled');
    e.currentTarget.classList.add('swiper-button-disabled');
    table.scrollTo({
      left: 0,
      behavior: 'smooth',
    });
  });

  function hasHorizontalScroll(el) {
    return el.scrollWidth > el.clientWidth;
  }

  if (hasHorizontalScroll(table)) {
    table.classList.add('overflow');
    buttons.style.display = 'block';
  } else {
    buttons.style.display = 'none';
    table.classList.remove('overflow');
  }

  window.addEventListener('scroll', function () {
    if (hasHorizontalScroll(table)) {
      table.classList.add('overflow');
      buttons.style.display = 'block';
    } else {
      buttons.style.display = 'none';
      table.classList.remove('overflow');
    }
  });

  table.addEventListener('scroll', function () {
    const isAtEnd = table.scrollLeft + table.clientWidth >= table.scrollWidth;
    if (isAtEnd) {
      buttonNext.classList.add('swiper-button-disabled');
      buttonPrev.classList.remove('swiper-button-disabled');
    } else {
      buttonNext.classList.remove('swiper-button-disabled');
      buttonPrev.classList.add('swiper-button-disabled');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
